import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClientXsrfModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { HttpRequestService } from './_services/http-request.service';
import { CoverPageComponent } from './cover-page/cover-page.component';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { SharedModule } from './shared.module';
import { UpgradeModule } from "@angular/upgrade/static";
import { PprHomePageComponent } from './ppr-home-page/ppr-home-page.component';
import { HeaderComponent } from './header/header.component';
import { DataSharingService } from './_services/data-sharing.service';
import { UrlHandlingStrategy, UrlTree, Router } from '@angular/router';
import { APP_BASE_HREF, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { HttpRequestInterceptor } from './_interceptors/http-request-interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChangePasswordComponent } from './header/change-password/change-password.component';

class CustomHandlingStrategy implements UrlHandlingStrategy {

  constructor() { }

  shouldProcessUrl(url: UrlTree) {
    return url.toString().startsWith("/ppr");
  }

  extract(url: UrlTree) {
    return url;
  }

  merge(newUrlPart: UrlTree, rawUrl: UrlTree) {
    return newUrlPart;
  }
}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/locale-", ".json");
}


@NgModule({
  declarations: [
    AppComponent,
    CoverPageComponent,
    PprHomePageComponent,
    HeaderComponent,
    ChangePasswordComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'XSRF-TOKEN',
      headerName: 'X-CSRF-TOKEN'
    }),
    AppRoutingModule,
    UpgradeModule,
    NgHttpLoaderModule.forRoot(),
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  exports: [SharedModule],
  providers: [
    HttpRequestService,
    [
      { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true }
    ],
    CookieService,
    {
      provide: APP_BASE_HREF,
      useValue: '!'
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: UrlHandlingStrategy,
      useClass: CustomHandlingStrategy
    }
  ],
  entryComponents: [AppComponent]
})

export class AppModule {

  constructor(private upgrade: UpgradeModule, translate: TranslateService, private dataSharingService: DataSharingService,
    private router: Router, cookieService: CookieService) {

    translate.addLangs(['en', 'nl', 'fr']);
    translate.setDefaultLang('nl');

    let cookieLanguage = cookieService.get('PORTAL_LANG_KEY');

    if (cookieLanguage) {
      translate.use(cookieLanguage);
    } else {
      cookieService.set('PORTAL_LANG_KEY', 'nl');
      cookieService.set('PORTAL_LANG_COUNTRY', 'NL');
    }
  }

  public ngDoBootstrap(app) {
    //TODO: Added this for now since if you were generating a report and then reloading, login page would appear with the report as well
    this.router.navigate(['/'], { queryParams: {} });
    app.bootstrap(AppComponent);
    
    this.upgrade.bootstrap(document.body, ["portalApp"]);
    this.dataSharingService.setRootScope(this.upgrade.$injector.get('$rootScope'));
  }
}